import { User, UserRole, UserRoleKey } from '@app/types/user';
import { USER_ROLES_LABELS } from '@app/utils/constants';

/**
 * 権限ラベルを取得
 */
export function getRoleLabel(role?: UserRoleKey): string {
  switch (role) {
    case UserRole.OWNER:
      return USER_ROLES_LABELS.OWNER;
    default:
      return '-';
  }
}

export const ROLE_OPTIONS: { label: string; value: string }[] = [
  { label: getRoleLabel(UserRole.OWNER), value: UserRole.OWNER },
];

export function getUserFullName(user?: User, separate = ''): string {
  return [
    user?.customFields?.familyName || '',
    user?.customFields?.firstName || '',
  ].join(separate);
}
